import { render, staticRenderFns } from "./MixedPurchaseOrder.vue?vue&type=template&id=33f2bd51&scoped=true"
import script from "./MixedPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./MixedPurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./MixedPurchaseOrder.vue?vue&type=style&index=0&id=33f2bd51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f2bd51",
  null
  
)

export default component.exports